// extracted by mini-css-extract-plugin
export var dayLabel = "_ig-0";
export var pickerDisabled = "_ig-1";